
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { getLastAuthPage } from '@/utils/localStorage';

interface SignInLinkProps {
  onSwitchMode?: () => void;
}

const SignInLink: React.FC<SignInLinkProps> = ({ onSwitchMode }) => {
  const navigate = useNavigate();
  
  const handleGoBack = () => {
    if (onSwitchMode) {
      onSwitchMode();
    } else {
      // Navigate to the last auth page or signin by default
      const lastAuthPage = getLastAuthPage();
      navigate(lastAuthPage);
    }
  };
  
  return (
    <>
      {/* Compact divider with reduced vertical space */}
      <div className="relative flex py-2.5 items-center my-1.5">
        <div className="flex-grow border-t border-gray-300 dark:border-gray-700"></div>
        <span className="flex-shrink-0 mx-3 text-xs text-gray-500 dark:text-gray-400">or</span>
        <div className="flex-grow border-t border-gray-300 dark:border-gray-700"></div>
      </div>
      
      <Button 
        variant="outline"
        className="w-full h-11 bg-white dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800/30 text-blue-500 dark:text-blue-300 rounded-full font-medium shadow-sm hover:bg-blue-50 dark:hover:bg-blue-900/30 hover:text-blue-400 dark:hover:text-blue-300 transform transition-all duration-200 ease-out hover:scale-[1.02] hover:shadow-lg active:scale-[0.98] active:shadow-md" 
        onClick={handleGoBack}
      >
        Sign in
      </Button>
      
      <p className="text-center text-sm text-gray-500 dark:text-gray-400 mt-6">
        Warning: May cause uncontrollable productivity! 🚀
      </p>
    </>
  );
};

export default SignInLink;
